/**
 * External Imports
 */

import { connect, useDispatch } from 'react-redux';
import { FC, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';
import { useAnalyticsApi } from '@shared-web-analytics/react';
/**
 * Internal Imports
 */
import { logReportsClick, ReportEvents } from '../../../utils/analyticsHelpers';
import TransitionalBarChart from '../../metricsChart/barChart/TransitionalBarChart';
import { RootState } from '../../../redux/store';
import { setFeedbackFilter } from '../../../redux/actions';
/**
 * Global Type Definition Imports
 */
import { ApiMetrics, Filter, MetricsData } from '../../../config/interfaces';
/**
 * Style Imports
 */
import {
  HeaderContainer,
  TaskMetricContainer,
  TitleContainer
} from '../CustomMetricCharts.styles';

interface RecognitionMetricChartProps {
  metrics: ApiMetrics;
  patientSummaryReportFilter: Filter;
}

const RecognitionMetricChart: FC<RecognitionMetricChartProps> = ({
  metrics,
  patientSummaryReportFilter
}) => {
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const { '*': view } = useParams();
  const { logTrackingEvent } = useAnalyticsApi();

  const metricsData: MetricsData = useMemo(() => {
    return {
      totalRecordsCount: metrics.totalRecordsCount,
      metrics: [
        {
          label: 'Opened',
          value: metrics.openedRecordsCount,
          color: '#df5828'
        },
        {
          label: 'Completed',
          value: metrics.completedRecordsCount,
          color: '#0077b5'
        }
      ]
    };
  }, [metrics]);

  const openFeedbackTable = () => {
    dispatch(
      setFeedbackFilter({
        ...patientSummaryReportFilter,
        taskSubType: 'recognition',
        category: '',
        subCategory: '',
        createdBy: '',
        patient: '',
        employeeId: ''
      })
    );
    if (view)
      logTrackingEvent(
        logReportsClick(view?.replace('/', '-'), 'recognition' as ReportEvents)
      );
    setTimeout(() => {
      navigateTo('/patients/feedback', {
        state: { from: view }
      });
    }, 1000);
  };

  return (
    <TaskMetricContainer onClick={openFeedbackTable}>
      <HeaderContainer style={{ paddingLeft: '3em' }}>
        <NeuIcon size="1x" color="purple" className="ms-1">
          campaign
        </NeuIcon>
        <TitleContainer style={{ marginLeft: '0.5rem' }}>
          {metrics.totalRecordsCount} Recognition
        </TitleContainer>
      </HeaderContainer>
      <TransitionalBarChart metricsData={metricsData} />
    </TaskMetricContainer>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    patientSummaryReportFilter: state.ReportReducer.patientSummaryReportFilter,
    metrics: state.TaskReducer.recognitionMetrics
  };
};
export default connect(mapReduxStateToProps)(RecognitionMetricChart);
